import React from 'react'

import { ToastContainer } from 'react-toastify'

import { useDisplay } from '@/theme'

import './toast.css'

const Toast = () => {
  const { isMobileView } = useDisplay()

  return (
    <ToastContainer
      theme='colored'
      stacked={true}
      position={isMobileView ? 'top-center' : 'bottom-center'}
    />
  )
}

export default Toast
